import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { OnboardingGate } from "../features/onboarding/OnboardingWizard";
import { KeyboardShortcuts } from "../features/shortcuts/KeyboardShortcuts";
import { useAutoSync } from "../features/sync/useAutoSync";
import { useAppStore } from "../state/app-store";
import { DateRangeProvider } from "../components/DateRangeContext";
import "./shell.css";

export function AppShell(): JSX.Element {
  const collapsed = useAppStore((s) => s.sidebarCollapsed);
  const mobileNavOpen = useAppStore((s) => s.mobileNavOpen);
  const closeMobileNav = useAppStore((s) => s.closeMobileNav);
  // Temporizador de sincronización programada (item 6): activo mientras la app está abierta.
  useAutoSync();
  return (
    <DateRangeProvider>
    <div className={`shell${collapsed ? " shell--collapsed" : ""}${mobileNavOpen ? " shell--nav-open" : ""}`}>
      {/* Accesibilidad (item 12): saltar la navegación e ir directo al contenido. */}
      <a href="#main-content" className="skip-link">Saltar al contenido</a>
      {/* Fondo para cerrar el drawer en móvil. */}
      <div className="sidebar-backdrop" onClick={closeMobileNav} aria-hidden="true" />
      <Sidebar />
      <div className="main">
        <Topbar />
        <main className="content" id="main-content" tabIndex={-1}>
          <div className="content__inner">
            <Outlet />
          </div>
        </main>
      </div>
      <OnboardingGate />
      <KeyboardShortcuts />
    </div>
    </DateRangeProvider>
  );
}
